export const asTextArray = (value) => {
  if (!Array.isArray(value)) return [];

  return value
    .map((item) => {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object') {
        return [item.question, item.answer].filter(Boolean).join(' - ');
      }
      return String(item || '');
    })
    .filter(Boolean);
};

export const asQuestionAnswerArray = (value) => {
  if (!Array.isArray(value)) return [];

  return value
    .map((item) => {
      if (typeof item === 'string') return { question: item, answer: '' };
      if (item && typeof item === 'object') {
        return {
          question: item.question || '',
          answer: item.answer || ''
        };
      }
      return null;
    })
    .filter((item) => item?.question || item?.answer);
};

export const buildLearningTopicPath = ({ slug, matterId, questionKey }) => {
  const params = new URLSearchParams();
  if (matterId) params.set('matterId', matterId);
  if (questionKey) params.set('questionKey', questionKey);

  const query = params.toString();
  return `/learning/${slug}${query ? `?${query}` : ''}`;
};

export const getPrimaryEducationTopic = (topics = []) => {
  return topics.find((row) => row?.topic) || null;
};

export const getQuestionHelpText = (question, topicRow) => {
  const topic = topicRow?.topic;

  if (topic) {
    return topicRow.immediate_context
      || topic.why_we_are_asking
      || topic.short_summary
      || topic.plain_english_explanation
      || question?.help_text
      || '';
  }

  return question?.help_text || '';
};

export const getLearningInvitationRows = (topics = []) => {
  return topics.filter((row) => row?.topic && row.show_help_cta);
};
